import type {
  ClientLoaderFunctionArgs,
  LinksFunction,
  LoaderFunctionArgs,
  MetaFunction,
} from 'react-router';

import { enhanceWithFilterState } from '@jane/bloom/loaders/clientLoader/filterStateManagement';
import { loadCustomRowRoute } from '@jane/bloom/loaders/routes/customRow.server';
import { customRowRouteMeta } from '@jane/bloom/resources/meta/routes/customRow';
import { plpStylesLinks } from '@jane/bloom/resources/plpStylesLinks';
import { ddTrace } from '@jane/bloom/services/dd-trace.server';
import type { RouteHandle } from '@jane/bloom/types/schemas/bloom/routeHandle';

import customRowStylesLink from './styles.css?url';
import customRowDesktopStylesLink from './styles.desktop.css?url';
import customRowMobileStylesLink from './styles.mobile.css?url';

export const handle: RouteHandle = {
  hydrate: true,
};

export const links: LinksFunction = () => [
  { href: customRowStylesLink, rel: 'stylesheet' },
  {
    href: customRowDesktopStylesLink,
    media: '(min-width: 767px)',
    rel: 'stylesheet',
  },
  {
    href: customRowMobileStylesLink,
    media: '(max-width: 767px)',
    rel: 'stylesheet',
  },
  ...plpStylesLinks,
];

export const meta: MetaFunction<typeof loader> = (args) => {
  return customRowRouteMeta(args);
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const serverLoader = await args.serverLoader<typeof loader>();
  const { filterArgs, searchCriteria } = serverLoader;
  return {
    ...serverLoader,
    availableFilters: await enhanceWithFilterState({
      filterArgs,
      searchCriteria,
    }),
  };
};
clientLoader.hydrate = true;

export const loader = async (args: LoaderFunctionArgs) =>
  ddTrace.initOnce().trace(
    'loader.$basename.rows.$customRowId.$slug',
    {
      measured: true,
    },
    async () => {
      return loadCustomRowRoute({ args });
    }
  );

export { CustomRowRouteComponent as default } from '@jane/bloom/components/routes/customRow/customRowRouteComponent';
